<template>
  <div class="w-full pt-20">
    <!--TITRE-->
    <div class=" text-center  ">
      <h1 class=" md:text-4xl sm:text-2xl text-xl mb-4 text-blue-800">
        Nos Spécialistes
      </h1>
      <hr class="W-1/4 mx-auto mb-10 shadow-4xl" />
    </div>

    <div
      class="w-auto   flex  justify-center    justify-center  lg:flex-row flex-wrap  "
    >
      <!--JOANNY-->
      <div
        class="bg-white rounded overflow-hidden shadow-2xl w-11/12 lg:w-1/3    lg:mx-8 mb-16 lg:mb-0 my-6   "
      >
        <div class="text-center p-6  border-b">
          <img
            class="h-24 w-24 rounded-full mx-auto"
            src="../assets/Joanny.jpg"
            alt="Joanny Schuberth"
          />
          <p class="pt-2 text-lg font-semibold">Joanny Schuberth</p>
          <p class="text-xs text-gray-600">SnivoStudio&copy;</p>
          <p class="text-sm text-gray-700 italic">
            "Bonjour je m'appel Joanny j'ai 23 ans ! Je suis monteur vidéo
            depuis 5 ans a titre non professionnel, et depuis peu de temps à
            titre professionnel suite à la création de ma micro entreprise."
          </p>
          <!--<div class="mt-5">-->
          <!--<a-->
          <!--href="#"-->
          <!--class="border rounded-full py-2 px-4 text-xs font-semibold text-gray-700"-->
          <!--&gt;-->
          <!--Manage your Account-->
          <!--</a>-->
          <!--</div>-->
        </div>
        <div class="">
          <a href="#" class="px-4 py-2 hover:bg-gray-100 flex">
            <div class="text-gray-800">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                class="w-8 h-8"
              >
                <path
                  d="M16 7l4-4v14l-4-4v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v3zm-8 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                />
              </svg>
            </div>
            <div class="pl-3">
              <p class="text-sm font-medium text-gray-800 leading-none">
                After Effect / Première pro
              </p>
              <p class="text-xs text-gray-500">
                Je maitrise after effect depuis des annees blablabla pouette
                gjklfjghoifg tfhkj tohjk opgfhjk ofghjfiohjdfk ghjjdfkghjik
                dfhgidufhg ukdfghudfi ghdufgh dufihiupfghkj
              </p>
            </div>
          </a>
          <a href="#" class="px-4 py-2 hover:bg-gray-100 flex">
            <div class="text-gray-800">
              <svg
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                viewBox="0 0 24 24"
                class="w-8 h-8"
              >
                <path
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                ></path>
              </svg>
            </div>
            <div class="pl-3">
              <p class="text-sm font-medium text-gray-800 leading-none">
                Première Pro
              </p>
              <p class="text-xs text-gray-500">
                Je fais aussi du montage vidéo
              </p>
            </div>
          </a>
          <a href="#" class="px-4 py-2 hover:bg-gray-100 flex">
            <div class="text-gray-800">
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                viewBox="0 0 24 24"
                class="w-8 h-8"
              >
                <path
                  d="M511.99 460.792c0 28.27-22.929 51.198-51.198 51.198H51.208C22.929 511.99.01 489.061.01 460.792V51.208C.01 22.929 22.929.01 51.208.01h409.584c28.27 0 51.198 22.919 51.198 51.198v409.584z"
                  fill="#9F7DB8"
                />
                <path
                  d="M511.99 419.813c0 28.27-22.929 51.198-51.198 51.198H51.208C22.929 471.011.01 448.082.01 419.813V51.208C.01 22.929 22.929.01 51.208.01h409.584c28.27 0 51.198 22.919 51.198 51.198v368.605z"
                  fill="#B597C7"
                />
                <g fill="#FFF">
                  <path
                    d="M242.03 312.407l-9.929-32.378h-57.838l-11.149 32.378h-34.689l55.948-156.863h38.048l55.248 156.863H242.03zm-38.988-121.675h-.24L182.733 253.1h39.968l-19.659-62.368zM303.488 262.33c.94 17.479 10.859 28.809 26.009 28.809 9.93 0 18.659-4.96 20.77-12.989h31.658c-7.1 23.858-26.249 37.328-51.008 37.328-38.738 0-58.128-21.259-58.128-63.308 0-35.918 20.539-59.077 56.198-59.077 35.679 0 54.588 23.159 54.588 69.237h-80.087zm48.449-19.38c-.48-17.249-11.83-25.509-23.85-25.509-12.27 0-22.488 9.439-23.658 25.509h47.508z"
                  />
                </g>
              </svg>
            </div>
            <div class="pl-3">
              <p class="text-sm font-medium text-gray-800 leading-none">
                Personal settings
              </p>
              <p class="text-xs text-gray-500">Email, profile, notifications</p>
            </div>
          </a>
          <a href="#" class="px-4 py-2 hover:bg-gray-100 flex">
            <div class="text-green-600">
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                viewBox="0 0 24 24"
                class="w-5 h-5"
              >
                <path
                  d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                />
              </svg>
            </div>
            <div class="pl-3">
              <p class="text-sm font-medium text-gray-800 leading-none">
                Apps &amp; integrations
              </p>
              <p class="text-xs text-gray-500">Google, slack, mail</p>
            </div>
          </a>
        </div>


      </div>
      <!--LAZARE-->
      <div
        class="bg-white rounded overflow-hidden shadow-2xl w-11/12 lg:w-1/3  lg:mx-8  mb-16 lg:mb-0 my-6  "
      >
        <div class="text-center p-6  border-b">
          <img
            class="h-24 w-24 rounded-full mx-auto"
            src="../assets/Lazare.jpg"
            alt="Lazare Chevereau"
          />
          <p class="pt-2 text-lg font-semibold">Lazare Chevereau</p>
          <p class="text-xs text-gray-600">LazareC&copy;</p>
          <p class="text-sm text-gray-700 italic">
            "Je suis développeurr web depuis plus de 5 ans, et monteur vidéo
            depuis 3 ans. Ma longue expérience me permet de répondre à tout type
            de demande et d'avoir une maîtrise sur toutes les créations
            audiovisuel."
          </p>

<!--          <div class="mt-5">-->
<!--          <a-->
<!--          href="#"-->
<!--          class="border rounded-full py-2 px-4 text-xs font-semibold text-gray-700"-->
<!--          >-->
<!--          Manage your Account-->
<!--          </a>-->
<!--          </div>-->
        </div>
        <div class="">
          <a class="px-4 py-2 flex">
            <div class="text-gray-800">
              <font-awesome-icon
                fixed-width
                class="text-2xl    h-auto py-2"
                :icon="['fas', 'desktop']"
              />
            </div>
            <div class="pl-3">
              <p class="text-sm font-medium text-gray-800 leading-none">
                Developpeur web / mobile
              </p>
              <p class="text-xs text-gray-500">
                Je développe des sites web pour des entreprises ou pour des
                projets personnels. Je maîtrise
                <strong
                  >le web et ses languages: HTML, CSS, Javascript,
                  PHP...</strong
                >
                Je développe aussi pour les smartphones Android et IOS..
              </p>
            </div>
          </a>
          <a class="px-4 py-2 flex">
            <div class="text-gray-800">
              <font-awesome-icon
                fixed-width
                class="text-2xl    h-auto py-2"
                :icon="['fas', 'camera']"
              />
            </div>
            <div class="pl-3">
              <p class="text-sm font-medium text-gray-800 leading-none">
                Photographe amateur
              </p>
              <p class="text-xs text-gray-500">
                Je fais aussi de la photo pendant des shootings amateurs il y a
                maintenant 2 ans. Cela m'a permis d'apprendre et de maîtriser
                Photoshop et Ligthroom
              </p>
            </div>
          </a>
          <a class="px-4 py-2 hover:bg-gray-100 flex">
            <div class="text-gray-800">
              <font-awesome-icon
                fixed-width
                class="text-2xl    h-auto py-2"
                :icon="['fas', 'video']"
              />
            </div>
            <div class="pl-3">
              <p class="text-sm font-medium text-gray-800 leading-none">
                Monteur vidéo
              </p>
              <p class="text-xs text-gray-500">
                J'ai monté plusieurs vidéos pour des Associations caritatives
                des petites entreprises et bien évidemment pour des
                particuliers! Je maîtrise Première Pro et After Effect
              </p>
            </div>
          </a>
          <a href="#" class="px-4 py-2 hover:bg-gray-100 flex">
            <div class="text-gray-800">
                <font-awesome-icon
                        fixed-width
                        class="text-2xl    h-auto py-2"
                        :icon="['fas', 'video']"
                />
            </div>
            <div class="pl-3">
              <p class="text-sm font-medium text-gray-800 leading-none">
                Apps &amp; integrations
              </p>
              <p class="text-xs text-gray-500">Google, slack, mail</p>
            </div>
          </a>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Personne"
};
</script>

<style scoped></style>
